import { createContext, useContext } from 'react';
export const PopoverManagerContext = /*#__PURE__*/createContext({
  activePopovers: new Map(),
  openPopover: () => 0,
  closePopover: () => {}
});
export function usePopoverManager() {
  const context = useContext(PopoverManagerContext);
  if (!context) {
    throw new Error(`usePopoverManager must be used within a PopoverManagerProvider`);
  }
  return context;
}
//# sourceMappingURL=usePopoverManager.js.map